module.exports = __webpack_public_path__ + "static/media/ecard_icon_right.75a8d16f.svg";